import type { Auth0ContextInterface, User } from '@auth0/auth0-react';
import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { createQueryCloudConnectSubscription } from 'src/api/queries';
import { userHelpers } from 'src/utils/userHelpers';

interface RedirectContext {
  auth: Promise<Auth0ContextInterface<User>>;
  queryClient: QueryClient;
}

// redirectSubscribedUserToSubscriptions redirects users with an active
// subscription to the subscriptions page.
// This is typically done for the checkout flow, where we don't want users with
// an active subscription to be able to purchase another subscription.
export async function redirectSubscribedUserToSubscriptions(
  context: RedirectContext
) {
  const auth = await context.auth;

  // First check token claims.
  if (
    userHelpers.hasSubscription(auth.user) ||
    userHelpers.isOrganizationMember(auth.user)
  ) {
    throw redirect({ to: '/subscriptions' });
  }

  // Auth0 subscription claims can be missing or stale. Use Cloud Connect as
  // the source of truth before allowing the user into Checkout V2.
  const subscription = await context.queryClient.ensureQueryData(
    createQueryCloudConnectSubscription()
  );

  if (subscription) {
    throw redirect({ to: '/subscriptions' });
  }
}
